export default "__VITE_ASSET__Dp4dGMgv__";